import { Spinner } from '../ui/spinner'

export function Loader() {
    return (
        <div className='size-full flex-1 flex items-center justify-center'>
            <Spinner className='size-10' />
        </div>
    )
}
